<template>
  <div class="jzliu-bi-engine-dws-table">
    <el-table
      header-row-class-name="table-header-gray"
      :data="tableData"
      style="width: 100%"
      :max-height="tableHeight"
      @sort-change="handleSortChange"
    >
      <el-table-column
        show-overflow-tooltip
        min-width="180"
        sortable
        v-for="item in columns"
        :prop="item.prop"
        :label="item.label"
      >
      <template slot-scope="scope">
        {{ scope.row[item.prop] || "-" }}
      </template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="margin-top: 10px"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryList.pageNum"
      :page-size="queryList.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="queryList.total"
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: "dwsTable",
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      columns: [],
      queryList: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
    };
  },
  computed: {
    tableData() {
      if (!this.data || this.data.length === 0) {
        return [];
      }
      const tempColumns = this.data[0];
      this.columns = Object.keys(tempColumns).map((key) => {
        return {
          prop: key,
          label: key,
        };
      });
      this.queryList.total = this.data.length;
      return this.data.slice(
        (this.queryList.pageNum - 1) * this.queryList.pageSize,
        this.queryList.pageNum * this.queryList.pageSize
      );
    },
    tableHeight() {
      return window.innerHeight - 260;
    },
  },
  methods: {
    handleSizeChange(size) {
      this.queryList.pageSize = size;
      this.queryList.pageNum = 1;
    },
    handleCurrentChange(page) {
      this.queryList.pageNum = page;
    },
    handleSortChange(column) {
      column.chartType = "dws";
      this.$emit("sort-change", column);
    },
  },
};
</script>

<style scoped lang="less">
</style>
